import { createContext } from "react";

export interface IAuthContext {
  user: { email: string } | null;
  userLoading: boolean;
  isLoggedIn: boolean;
  accessError: string | null;
  connectorId: number | null;
  isSuperAdmin: boolean;
  selectedConnectorId: number | null;
  setSelectedConnectorId: (id: number | null) => void;
  idToken: string | null;
  logout: () => void;
}

export const AuthContext = createContext<IAuthContext>({
  user: null,
  userLoading: true,
  isLoggedIn: false,
  accessError: null,
  connectorId: null,
  isSuperAdmin: false,
  selectedConnectorId: null,
  setSelectedConnectorId: () => {},
  idToken: null,
  logout: () => {},
});
